// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { GridOffset } from "@insite/mobius/GridContainer";
import { documentsStyles } from "@pace/Overrides/Widgets/ProductDetails/ProductDetailsDocuments";
import IconDocumentation from "@pace/XDL/Icons/IconDocumentation";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, createLinkIconStyles } from "@pace/XDL/Utilities";
import { css } from "styled-components";

documentsStyles.wrapper = {
    css: css`
        padding: 17px;
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        @media print {
            display: none;
        }
    `,
};

documentsStyles.container = {
    gap: 12,
    css: css`
        ${GridOffset} {
            flex-direction: column;
        }
    `,
};

documentsStyles.documentGridItem = {
    width: 12,
};

documentsStyles.title = {
    variant: "h6",
    forwardAs: "span",
    css: css`
        margin: 0;
        width: 100%;
    `,
};

documentsStyles.documentLink = {
    ...createLinkIconStyles(
        IconDocumentation,
        {
            css: css`
                align-items: flex-start;
            `,
        },
        css`
            font-size: 16px;
            line-height: 22px;
            font-weight: ${fontConfig.weight.bold};
            margin: 0;
        `,
        css`
            &,
            svg {
                height: auto;
                width: 12px;
                margin-top: 2px;
            }
        `,
        "left",
    ),
};
